module.exports = __webpack_public_path__ + "static/media/suicidalityActive.7105e1da.svg";